module.exports = require('./lib/client');



//////////////////
// WEBPACK FOOTER
// ./~/@feathersjs/transport-commons/client.js
// module id = 220
// module chunks = 0